module.exports = __webpack_public_path__ + "img/aomen4.7ecb0113.jpg";